import { CommonModule }    from '@angular/common';
import { FormsModule }     from '@angular/forms';
import { NgModule }        from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import {
  NgbProgressbarModule,
  NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';

import { ControlClearerComponent }      from './control-clearer/control-clearer.component';
import { CopyToClipboardDirective }     from './copy-to-clipboard/copy-to-clipboard.component';
import { FlipperComponent }             from './flipper/flipper.component';
import { FormSubmitValidatorDirective } from './form-submit.validator.directive';
import { IconComponent }                from './icon/icon.component';
import { ImageViewModule }              from './image-viewer/image-viewer.module';
import { ListBoxComponent }             from './list-box/list-box.component';
import { TooltipDirective }             from './tooltip/tooltip.directive';
import { WizardComponent }              from './wizard/wizard.component';
import { WizardStepComponent }          from './wizard/wizard.step.component';

@NgModule({
  declarations: [
    ControlClearerComponent,
    CopyToClipboardDirective,
    FlipperComponent,
    FormSubmitValidatorDirective,
    IconComponent,
    ListBoxComponent,
    TooltipDirective,
    WizardComponent,
    WizardStepComponent
  ],
  entryComponents: [
    ControlClearerComponent,
    CopyToClipboardDirective,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  exports: [
    // Third Party
    CommonModule,
    FormsModule,
    NgbTooltipModule,

    // Custom
    ControlClearerComponent,
    CopyToClipboardDirective,
    FlipperComponent,
    FormSubmitValidatorDirective,
    IconComponent,
    ImageViewModule,
    ListBoxComponent,
    TooltipDirective,
    WizardComponent,
    WizardStepComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Third Party
    NgbProgressbarModule,
    NgbTooltipModule,
    TranslateModule,

    //Custom
    ImageViewModule
  ]
})
export class ComponentsModule {}
